import { render } from "./EconomicView.vue?vue&type=template&id=437fd9c3&scoped=true"
import script from "./EconomicView.vue?vue&type=script&lang=js"
export * from "./EconomicView.vue?vue&type=script&lang=js"

import "./EconomicView.vue?vue&type=style&index=0&id=437fd9c3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437fd9c3"]])

export default __exports__